
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      default: () => null,
    },
    season: {
      type: Object,
      default: () => null,
    },
    player: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: `Compare Players`,
    },
  },
  provide () {
    return {
      team: this.activeTeam,
      season: this.activeSeason,
    };
  },
  data () {
    return {
      players: [], // Selectable players
      teams: [], // Selectable teams
      selectedTeamIds: [], // The team IDs of the active players
      playerStats: {
        0: {},
        1: {},
      }, // Active player stats
      currentTab: `General`,
      playerStatsEnabled: false,
      selectedPlayerPositions: [],
      showGoalkeeperStats: false,
    };
  },
  computed: {
    gridClass () {
      return `col-1 col-${this.slots.length}-lt gap-1`;
    },
    slots () {
      return this.config.slots;
    },
    teamOnly () {
      return this.config.team_only;
    },
    // Select Box Options
    sortedTeams () {
      if (this.teams.length) {
        return [...this.teams].sort((a, b) => a.teamNames[0].displayName.localeCompare(b.teamNames[0].displayName));
      }
      return [];
    },
    sortedPlayers () {
      if (this.players.length) {
        const currentPlayers = [...this.players].filter(player => !player.onLoanTo);
        return currentPlayers
          .sort((a, b) => this.getKnownAs(a.player, true).localeCompare(this.getKnownAs(b.player, true)))
          .map(player => player.player);
      }
      return [];
    },
    // Stats
    allStats () {
      const statGroups = this.config.block_type === `default`
        ? this.additionalConfig?.player_comparison_config?.comparison_default_groups
        : this.config.stat_groups;
      return statGroups;
    },
    allStatNames () {
      const statNames = [];
      if (this.allStats) {
        for (const statGroup of this.allStats) {
          if (statGroup.stats) {
            for (const stat of statGroup.stats) {
              if (stat.stat.computedplayerstattype.length) {
                statNames.push(stat.stat.computedplayerstattype[0].displayName);
              }
              if (stat.stat.playerstattype.length) {
                statNames.push(stat.stat.playerstattype[0].displayName);
              }
            }
          }
        }
      }
      return statNames;
    },
    tabs () {
      let allTabs = this.allStats ? this.allStats.map(group => group.title) : [];
      if (!this.showGoalkeeperStats) {
        allTabs = allTabs.filter(tab => !tab.startsWith(`Goalkeep`));
      }

      return allTabs;
    },
    currentStatGroup () {
      if (this.allStats) {
        const group = this.allStats.find(group => group.title === this.currentTab);
        return group ? group.stats : [];
      }
      return [];
    },
    activeSeason () {
      return this.season || this.getDefault(`season`);
    },
    activeTeam () {
      return this.team || this.getDefault(`team`);
    },
  },
  watch: {
    tabs () {
      this.currentTab = this.tabs[0];
    },
    playerStats: {
      handler (val) {
        if (val[1] && Object.keys(val[1]).length) {
          this.playerStatsEnabled = true;
        } else {
          this.playerStatsEnabled = false;
        }
      },
      deep: true,
    },
    selectedPlayerPositions: {
      handler (val) {
        if (val.includes(`Goalkeeper`)) {
          this.showGoalkeeperStats = true;
        } else {
          this.showGoalkeeperStats = false;
        }
      },
      deep: true,
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.teamOnly) {
        this.getPlayers(this.activeTeam.id);
      } else {
        this.getLeagueTeams();
      }
    });
  },
  methods: {
    async getLeagueTeams () {
      const params = {
        include: `squads.team`,
      };

      const request = await this.$getStats(`season/${this.activeSeason.id}`, params);
      if (request !== null) {
        this.teams = request.data.squads.map(squad => squad.team);
      }
    },
    async getPlayers (teamId) {
      const params = {
        include: `playerSquads.player.images`,
        filter: {
          teamId,
          seasonId: this.activeSeason.id,
        },
        filterIncludes: {
          'playerSquads.player.images.description': `headshot`,
        },
      };

      const request = await this.$getStats(`squad`, params);
      if (request !== null) {
        this.players = request.data[0].playerSquads;
      }
    },
    setTab (tab) {
      this.currentTab = tab;
    },
  },
};
